import { Link, useMediaQuery, useTheme } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'v2/components/Shared/Modal';

import mobileCreation from './mobile-creation.png';
import { useStyles } from './styles';

type AppRedirectModalProps = {
  isOpen: boolean;
  setClose: () => void;
};

function AppRedirectModal({ isOpen, setClose }: AppRedirectModalProps) {
  const classes = useStyles();
  const history = useHistory();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));
  const APP_REDIRECT_URL = 'https://app.eduzz.com/?s=eyJzIjoiQmFua0FjY291bnQiLCJwIjp7ImNyZWF0ZUFjY291bnQiOnRydWV9fQ==';

  const handleGoToAddBankAccount = () => {
    history.push('/producer/profile/add-bank-account');
  };

  const handleRedirectToApp = () => {
    window.open(APP_REDIRECT_URL, '_blank');
    setClose();
  };

  return (
    <Modal
      open={isOpen}
      textTitle='Cadastrar nova conta bancária'
      textReturnButton='Cadastrar pelo site'
      textProceedButton='Cadastrar pelo App'
      setClose={setClose}
      handleProceedClick={handleRedirectToApp}
      handleReturnClick={handleGoToAddBankAccount}
    >
      <div className={classes.container}>
        <div>
          <p className={classes.subtitle}>Chegou a hora de cadastrar sua conta bancária!</p>
          <p className={classes.text}>
            Facilitamos o caminho para você receber suas vendas. <b>Cadastre sua nova conta pelo App Eduzz e consiga aprovação de forma imediata.</b>
          </p>
          <p className={classes.text}>
            {!isMobile
              ? 'Abra sua câmera, escaneie o código ao lado e cadastre sua conta.'
              : 'Clique em "Cadastrar pelo App” e cadastre sua nova conta.'}
          </p>
          <p className={classes.text}>
            <Link
              href='https://ajuda.eduzz.com/hc/pt-br/articles/4408955665051-Como-cadastrar-minha-conta-banc%C3%A1ria-no-App-Eduzz-'
              target='_blank'
              rel='noopener noreferrer'
            >
              Saiba mais.
            </Link>
          </p>
        </div>
        <div className={classes.qrcode}>
          {!isMobile ? <QRCodeSVG value={APP_REDIRECT_URL} /> : <img src={mobileCreation} alt='Criar conta bancária mobile' />}
        </div>
      </div>
    </Modal>
  );
}

export { AppRedirectModal };
